<mat-card appearance="outlined">
  <form [formGroup]="form">
    <div class="row">
      <div class="col">
        <p>
          <strong [innerText]="title"></strong>
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Motivo del rechazo</mat-label>
          <textarea matInput formControlName="rechazo" name="rechazo" rows="5"></textarea>
          <mat-error *ngIf="form.controls['rechazo'].hasError('required')">
            <small>
              El motivo del rechazo es <strong>obligatorio</strong>
            </small>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-center flex-column flex-md-row">
          <ng-container>
            <button class="me-0 me-md-2 mb-2 mb-md-0" mat-stroked-button (click)="rechazar()">
              <mat-icon>done</mat-icon>
              Rechazar
            </button>
          </ng-container>
          <button mat-stroked-button (click)="cancel()">
            <mat-icon>close</mat-icon>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </form>
</mat-card>